/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CancelExclusionFromBackupResponse {
  /**
  * Whether the call was successful. Expected to be `true`. 
  */
  'isExclusionCanceled': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "isExclusionCanceled",
      "baseName": "isExclusionCanceled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CancelExclusionFromBackupResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

